"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracker = void 0;
var Tracker = /** @class */ (function () {
    function Tracker() {
    }
    Tracker.getAttributeTypeMap = function () {
        return Tracker.attributeTypeMap;
    };
    Tracker.attributeTypeMap = [
        {
            name: 'name',
            baseName: 'name',
            type: 'string',
        },
        {
            name: 'version',
            baseName: 'version',
            type: 'string',
        },
    ];
    return Tracker;
}());
exports.Tracker = Tracker;
//# sourceMappingURL=tracker.js.map